import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { CustomerService, CustomersMenuGet, GetCustomersMenuParams } from '@app/services/customer.service';

@Component({
    selector: 'tt-customers-menu',
    templateUrl: './customers-menu.component.html',
    styleUrls: ['./customers-menu.component.css'],
})
export class CustomersMenuComponent implements OnInit {
    @Input()
    public params?: GetCustomersMenuParams;

    public get?: CustomersMenuGet;

    public contactsGrid: GridOptions = new Grid().setRememberId('w_customersmenu_person_grid').setLoadDataFunction({ method: 2968, parameters: () => this.params });

    public contactsGridLoaded = false;

    public emailGridLoaded = false;

    public projectsGridLoaded = false;

    public activitiesGridLoaded = false;

    public ordersGridLoaded = false;

    public documentsGridLoaded = false;

    public powtimesGridLoaded = false;

    public discountsGrid: GridOptions = new Grid().setRememberId('customersmenu_discgrpprod_rates_grid').setLoadDataFunction({ method: 3125, parameters: () => ({ cust_no: this.get!.cust_no }) });

    public discountsGridLoaded = false;

    constructor(
        private customer: CustomerService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {
        this.navigator = useNavigatorFor(navigator, this);
    }

    public openLink(link: string) {
        window.open(link);
    }

    public onTabSelected(id: string) {
        if (id === 'CONTACTS') {
            this.contactsGridLoaded = true;
        } else if (id === 'EMAIL') {
            this.emailGridLoaded = true;
        } else if (id === 'PROJECTS') {
            this.projectsGridLoaded = true;
        } else if (id === 'CUSTACTS') {
            this.activitiesGridLoaded = true;
        } else if (id === 'ORDERS') {
            this.ordersGridLoaded = true;
        } else if (id === 'DOCUMENTS') {
            this.documentsGridLoaded = true;
        } else if (id === 'POWTIMES') {
            this.powtimesGridLoaded = true;
        } else if (id === 'DISCGRPPROD') {
            this.discountsGridLoaded = true;
        }
    }

    private async loadGet() {
        if (!!this.params && typeof this.params === 'object' && 'cust_no' && this.params && !isNaN(+this.params.cust_no)) {
            this.get = await this.customer.getCustomersMenu(this.params);
        } else {
            console.warn('invalid parameters provided to customer edit');
            console.dir(this.params);
        }
    }

    private async init() {
        await this.loadGet();
        this.navigator?.setHeading?.(this.get?.cust_name ?? '');
        this.onTabSelected(this.get!.bg_tab1);
    }

    ngOnInit(): void {
        if (!!this.navigator) {
            this.navigator.setSize?.({ width: 'min(180rem, 98vw)', height: '95vh' });
            this.params = this.navigator.params as any;
            this.init();
        }
    }
}
